import { useContext } from 'react';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import SubscriptionContext from '../../contexts/subscription/SubscriptionContext';

// Resolves the subscription a member (non-supervisor) is assigned to, same cross-reference
// as useUsersPageController.ts (userDoc.idSubscription keys ∩ the company's subscriptions)
export const useMySubscriptionId = (): string | undefined => {
  const { userDoc } = useContext(AuthenticationContext);
  const { subscriptions } = useContext(SubscriptionContext);

  const userSubIds = Object.keys(userDoc?.idSubscription || {});
  return subscriptions.find((sub) => userSubIds.includes(sub.id))?.id;
};
